<template>
  <div class="change-money-refund-page">

    <div class="change-money">
      <div class="change-title">充值金额</div>
      <div class="money-select">
        <div class="flex-money"
             :class="{'no-mg':(index +1)%3 == 0,'active' : selectMoney == item}"
             v-for="(item,index) in moneyArr"
             :key="index"
             @click="select(item)">¥{{item}}
        </div>
      </div>
    </div>
    <div class="sub-change">
      <div class="tips-text">点击立即充值即表示您已阅读并同意
        <router-link to="/recharge/protocol">《充值协议》</router-link>
      </div>
      <pi-button :type="loading ? 'default' : 'primary'"
                 block
                 @click="recharge">立即充值</pi-button>
    </div>
  </div>
</template>

<script>
import { Divider } from "vant";
import {
  queryPayResult,
  makePayOrder,
  makePayOrderXl,
  // getAccount,
  getUserAccount,
  getOprCongifInfo,
  ccbPayOrder
} from "../../common/api";
/* global WeixinJSBridge */
let toast = null;
export default {
  name: "change-money",
  components: {
    [Divider.name]: Divider,
  },
  data() {
    return {
      money: 30,
      data: {},
      minCharge: 0,
      moneyArr: [ 30, 50, 100],
      selectMoney: 30,
      isActivity: false,
      rechargeOrderNo: null,
      order: null,
      accountPkId: null,
      queryCount: 0,
      accountObj: {},
      loading: false,
      oprInfo: {},
    };
  },
  mounted() {
    this.getUserAccountList();
    this.getOprCongifInfo();
  },
  methods: {
    async getOprCongifInfo(){
      let ret = await getOprCongifInfo({});
      if (
          ret.status === this.$config.ajaxStatus &&
          ret.data.length > 0
        ) {
          this.oprInfo = ret.data[0];
        }
    },

    getUserAccountList() {
      //获取获取账号信息
      let that = this;
      this.loading = true;
      getUserAccount({})
        .then(response => {
          if (
            response.status === that.$config.ajaxStatus &&
            response.data.length > 0
          ) {
            var accountObj = response.data[0];
            this.accountObj = accountObj;
            this.accountPkId = accountObj.accountPkId;
          }
          this.loading = false;
        })
        .catch(()=> {
          this.loading = false;
        });
    },

    select(item) {
      this.selectMoney = item;
      this.money = item;
    },
    async recharge() {

      let getPay;
      let data = {
        accountPkId: this.accountPkId,
        accountType: this.accountObj.accountType,
        rechargeAmount: this.money,
        appType: 1,
        consumptionPattern: 2 //  既充即退
      }
      if(this.oprInfo.wxPayMethod == 2){
        getPay = makePayOrderXl;
        data.appType = 6;
      }else if(this.oprInfo.wxPayMethod == 3){
      // 天津建行支付
        data.appType = 9
        getPay = await ccbPayOrder(data);
      }else{
        getPay = makePayOrder
      }
      getPay(data)
        .then(data => {
          console.log(data);
          if (data.status === this.$config.ajaxStatus) {
            this.order = data.data[0];
            if (typeof WeixinJSBridge === "undefined") {
              if (document.addEventListener) {
                document.addEventListener(
                  "WeixinJSBridgeReady",
                  this.onBridgeReady,
                  false
                );
              } else if (document.attachEvent) {
                document.attachEvent("WeixinJSBridgeReady", this.onBridgeReady);
                document.attachEvent(
                  "onWeixinJSBridgeReady",
                  this.onBridgeReady
                );
              }
            } else {
              this.onBridgeReady();
            }
          } else {
            this.$toast(data.msg);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    queryPayResult() {
      queryPayResult({
        rechargeOrderNo: this.order.rechargeOrderNo
      })
        .then(data => {
          console.log(data);
          // alert(JSON.stringify(data));
          if (data.status === this.$config.ajaxStatus) {
            if (data.data.length > 0 && data.data[0].orderStatus === 6) {
              toast.clear();
              //支付成功
              let currentMoney = data.data[0].afterBalance;
              this.$dialog
                .alert({
                  title: "充值成功",
                  message: "当前余额" + currentMoney,
                  confirmButtonText: "关闭",
                  confirmButtonColor: "#999999",
                  closeOnPopstate: true
                })
                .then(() => {
                  // on confirm
                  this.$common.save('recharge-refund-success',this.money)
                  this.$router.go(-1);
                })
                .catch(() => {
                  // on cancel
                });
            } else {
              throw new Error();
            }
          } else {
            throw new Error();
          }
        })
        .catch(error => {
          console.log(error);
          this.queryCount--;
          if (this.queryCount <= 0) {
            this.queryCount = 0;
            // this.$toast('充值成功，还没有收到到账通知，请稍后刷新查看余额！');
            toast.clear();
            this.$dialog
              .alert({
                title: "提示",
                message: "充值成功，还没有收到到账通知，请稍后刷新查看余额",
                confirmButtonText: "关闭",
                confirmButtonColor: "#999999",
                closeOnPopstate: true
              })
              .then(() => {
                // on confirm
              })
              .catch(() => {
                // on cancel
              });
          } else {
            setTimeout(() => {
              this.queryPayResult();
            }, 3000);
          }
        });
    },
    /**
     * 微信内H5调起支付
     * https://pay.weixin.qq.com/wiki/doc/api/jsapi.php?chapter=7_7&index=6
     */
    onBridgeReady() {
      WeixinJSBridge.invoke(
        "getBrandWCPayRequest",
        {
          appId: this.order.appId,
          timeStamp: this.order.timeStamp,
          nonceStr: this.order.nonceStr,
          package: this.order.package,
          signType: this.order.signType,
          paySign: this.order.paySign
        },
        res => {
          if (res.err_msg == "get_brand_wcpay_request:ok") {
            console.log("pay success");
            // 使用以上方式判断前端返回,微信团队郑重提示：
            //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
            toast = this.$toast.loading({
              duration: 0,
              forbidClick: true,
              message: "请稍后..."
            });
            this.queryCount = 10;
            this.queryPayResult();
          } else {
            console.log("pay error");
            this.$dialog
              .alert({
                title: "充值失败",
                confirmButtonText: "关闭",
                confirmButtonColor: "#999999",
                closeOnPopstate: true
              })
              .then(() => {
                // on confirm
                this.$router.go(-1);
              })
              .catch(() => {
                // on cancel
              });
          }
        }
      );
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/less/old/var.less";

.change-money-refund-page {
  display: flex;
  flex-direction: column;
  height: 100%;


  .change-money {
    flex: 1;
    
    padding: 0.2rem 0.2rem 2.4rem 0.2rem;


    .money-select {
      margin-top: 1rem;;
      display: flex;
      flex-wrap: wrap;

      .flex-money {
        width: 2.19rem;
        margin-right: 0.24rem;
        margin-bottom: 0.24rem;
        color: #999999;
        font-size: 0.34rem;
        line-height: 0.48rem;
        background-color: #f7f7f7;
        text-align: center;
        border-radius: 0.1rem;
        padding: 0.18rem 0;
        box-sizing: border-box;
        border: 0.02rem solid #f7f7f7;
      }

      .flex-money.active {
        background: rgba(20, 204, 128, 0.13);
        border-color: #14cc80;
        color: #14cc80;
      }

      .flex-money.no-mg {
        margin-right: 0;
      }
    }

    .change-title {
      margin-top: 0.2rem;
      .size;
      color: #666666;
    }
  }

  .sub-change {
    justify-content: flex-end;
    position: fixed;
    left: 0;
    bottom: 0;
    box-sizing: border-box;
    width: 100%;
    padding: 0 0.4rem 0.2rem 0.4rem;
    background-color: #fff;
    .tips-text {
      color: #999;
      margin-bottom: 0.2rem;
      text-align: center;
      .mini-size;

      a {
        color: @blue;
      }
    }

  }
}
</style>
